<template>
  <!-- <div class="search-box" :class="activeSearch ? 'active' : ''">
    <input
      v-click-outside="onClickOutside"
      type="search"
      placeholder="Type to search"
      v-model="searchValue"
      @keyup="searchFilter(searchValue)"
      @click="active(true)"
      v-spaceRemove
    />
    <button type="reset" class="search-reset-btn" v-if="showClearIcon" @click="resetSearch">
      <i class="las la-times search-clear"></i>
    </button>
    <i class="fa fa-search search-animation cursor-pointer" @click="searchFilter(searchValue)"></i>
  </div>-->
  <div class="searchBox" :class="activeSearch ? 'active' : ''">
    <input
      type="search"
      id="deviceSearch"
      name="csearch"
      aria-label="Search through customer content"
      placeholder="Type to search"
      v-model="searchValue"
      @keyup="searchFilter($event, searchValue)"
      @keypress="preventPress($event, searchValue)"
      autocomplete="off"
    />
    <button
      type="reset"
      class="search-reset-btn"
      v-if="showClearIcon"
      @click="resetSearch"
    >
      <i class="la la-close search-clear darkgreyText"></i>
    </button>
    <button class="searchBtn">
      <i class="las la-search"></i>
    </button>
  </div>
</template>
<script>
export default {
  name: "SearchIcon",
  data: () => {
    return {
      searchValue: "",
      userList: [],
      showClearIcon: false,
      activeSearch: false,
    };
  },
  methods: {
    active(flagsearch) {
      this.activeSearch = flagsearch;
    },
    resetSearch() {
      this.searchValue = "";
      this.activeSearch = false;
      this.showClearIcon = false;
      this.$emit("onClearSearch", false);
    },
    preventPress(event, searchText) {
      if (event.which === 32 && !searchText.length) event.preventDefault();
    },
    searchFilter(event, searchText) {
      if (event.which !== 32 && (event.which <16 || event.which >18) && (event.which <37 || event.which > 40)) {
        this.$emit("onEmitSearch", searchText.trim());
        this.activeSearch = true;
      }
      if (this.searchValue === "") {
        this.showClearIcon = false;
      } else {
        this.showClearIcon = true;
      }
    },
    onClickOutside() {
      if (this.searchValue === "") {
        this.activeSearch = false;
      } else {
        this.activeSearch = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
